<script>
import {
  canRequestRefund,
  getBackendRefundDisabledReason,
  REFUND_SUBJECT_CHARGE,
} from "../refundEligibility";
import Button from "../components/Button.vue";
import RefundIcon from "@src/shared/icons/refund.svg";

export default {
  emits: ["refund"],
  components: {
    Button,
  },
  data() {
    return {
      refundIcon: RefundIcon,
    };
  },
  props: {
    charge: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canRefundCharge() {
      return canRequestRefund(this.$store);
    },
    disabledReason() {
      return getBackendRefundDisabledReason({
        hasPermission: this.canRefundCharge,
        canRefund: this.charge.can_refund,
        refundBlockedReason: this.charge.refund_blocked_reason,
        status: this.charge.status,
        subject: REFUND_SUBJECT_CHARGE,
      });
    },
    tooltip() {
      return this.disabledReason || "Reembolsar";
    },
  },
};
</script>

<template>
  <Button
    :disabled="!!disabledReason"
    :tooltip="tooltip"
    :expand-on-hover="false"
    label="Reembolsar"
    :icon-src="refundIcon"
    @click="$emit('refund', charge)"
  />
</template>
